//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    links: Array
  },
  methods: {
    getLink (link) {
      return (link !== null) ? link : ''
    }
  }
}

